import React, { useState, useEffect, useRef, useCallback } from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Button } from "primereact/button";
import { InputText } from "primereact/inputtext";
import { Dialog } from "primereact/dialog";
import { InputSwitch } from "primereact/inputswitch";
import { Toast } from "primereact/toast";
import { Tag } from "primereact/tag";
import { useDispatch, useSelector } from "react-redux";
import { loading } from "../../actions";
import { ConfirmDialog, confirmDialog } from "primereact/confirmdialog";
import classNames from "classnames";
import { useHistory } from "react-router-dom";
import ApiFunctions from '../../service/Api'
import { addLocale } from "primereact/api";
import { nullToString, stringToDate, dateHHmmToHHmm, dateToString, dateToStringHHmm, isObject } from "../../utilities/Funcion";
import { accionPermiso } from "../../utilities/Seguridad";
import { Formik, Form, Field, ErrorMessage } from 'formik';
import { Calendar } from "primereact/calendar";
import { Dropdown } from "primereact/dropdown";
import * as Yup from 'yup';

export const PageFestivo = () => {
    const toast = useRef(null);
    const dispatch = useDispatch()
    const { POST, GET, PUT, DELETE } = ApiFunctions();

    const claseData = {
        id: null,
        fecha: '',
        descripcion: '',
        idcolegio: null,
        estado: 1
    }

    const [globalFilter, setGlobalFilter] = useState("");
    const [visibleDialog, setVisibleDialog] = useState(false);
    const [dataTable, setDataTable] = useState(claseData);
    const [selectedRecord, setSelectedRecord] = useState(null);
    const labelDialog = useRef({ title: "", labelButton: "", visible: false, es_nuevo: false });

    // Permisos
    const history = useHistory();
    const permisos = useRef({ superusuario: false, acciones: [] });
    const { usuario, colegio, anio } = useSelector((state) => ({
        usuario: state.usuario,
        colegio: state.colegio,
        anio: state.anio,
    }));

    try {
        permisos.current.superusuario = usuario.superusuario;
        permisos.current.acciones = usuario.permisos.mantenedor.dias_festivos.acciones;
    } catch (error) {
        permisos.current.acciones = [];
    }

    useEffect(() => {
        if (accionPermiso(permisos, "festivo_ver")) {
            loadLista();
        } else {
            history.push("/Acceso");
        }
    }, [anio]);

    const loadLista = async () => {

        if (!colegio.id) return;
        dispatch(loading(true));
        let response = await GET('festivo', 'listar', [anio.anio, colegio.id]);
        if (response.error) {
            toast.current.show({ severity: "error", summary: "Error", detail: response.mensaje, life: 3000 });
        } else {
            setDataTable(response.data);
        }
        dispatch(loading(false));
    }

    const viewNuevo = () => {
        setVisibleDialog(true);
        labelDialog.current.title = "Nuevo día Festivo";
        labelDialog.current.labelButton = "Registrar";
        labelDialog.current.es_nuevo = true;
        setSelectedRecord(claseData);
    }

    const viewEditar = (row) => {
        labelDialog.current.visible = true;
        labelDialog.current.title = "Actualizar Cuadra";
        labelDialog.current.labelButton = "Actualizar";
        labelDialog.current.es_nuevo = false;
        let dataEdit = { ...row };
        dataEdit.fecha = stringToDate(row.fecha)
        setSelectedRecord(dataEdit)
        setVisibleDialog(true);

    }

    const hideDialog = () => {
        setVisibleDialog(false);
        labelDialog.current.visible = false;
    }

    addLocale("es", {
        firstDayOfWeek: 1,
        dayNames: ["domingo", "lunes", "martes", "miércoles", "jueves", "viernes", "sábado"],
        dayNamesShort: ["dom", "lun", "mar", "mié", "jue", "vie", "sáb"],
        dayNamesMin: ["D", "L", "M", "X", "J", "V", "S"],
        monthNames: ["enero", "febrero", "marzo", "abril", "mayo", "junio", "julio", "agosto", "septiembre", "octubre", "noviembre", "diciembre"],
        monthNamesShort: ["ene", "feb", "mar", "abr", "may", "jun", "jul", "ago", "sep", "oct", "nov", "dic"],
        today: "Hoy",
        clear: "Claro",
    });

    const bodyTemplate = (data, props) => {
        return (
            <>
                <span className="p-column-title">{props.header}</span>
                {data[props.field]}
            </>
        )
    }

    const bodyTemplateActivo = (data, props) => {
        return (
            <>
                <span className="p-column-title">{props.header}</span>
                <Tag className="p-mr-2" severity={data[props.field] == 1 ? "success" : "warning"} value={data[props.field] == 1 ? "ACTIVO" : "INACTIVO"}></Tag>
            </>
        )
    }

    const eliminar = async (row) => {
        dispatch(loading(true));
        var response = await DELETE('festivo', 'eliminar', row.id);
        if (response.error) {
            toast.current.show({ severity: 'error', summary: 'Error', detail: `${!response.message}${response.detalle ? `. Detalles: ${response.detalle}` : ''}`, life: 3000 });
            
        } else {
            loadLista();
            toast.current.show({ severity: "success", summary: "OK", detail: "Registro Eliminado!", life: 3000 });
        }
    };

    const confirmDelete = (row) => {
        confirmDialog({
            message: "Estas seguro de eliminar registro",
            header: "Eliminar Confirmar",
            icon: "pi pi-info-circle",
            acceptClassName: "p-button-danger",
            accept: () => eliminar(row),
        });
    };


    const dataTableHeader = (
        <div className="table-header">
            <span className="p-input-icon-left">
                <i className="pi pi-search" />
                <InputText value={globalFilter} onChange={(e) => setGlobalFilter(e.target.value)} placeholder="Buscar..." />
            </span>

            <div className="flex align-items-center export-buttons">
                {accionPermiso(permisos, "festivo_crear") ? <Button type="button" icon="pi pi-plus" label="Día" className="mr-2 p-mr-1" onClick={viewNuevo} tooltip="Nuevo registro" tooltipOptions={{ position: "bottom", mouseTrack: true, mouseTrackTop: 15 }}></Button> : ""}
                <Button type="button" icon="pi pi-refresh" className="mr-2" onClick={loadLista} tooltip="Actualizar" tooltipOptions={{ position: "bottom", mouseTrack: true, mouseTrackTop: 15 }}></Button>
            </div>
        </div>
    );

    const monthNavigatorTemplate = (e) => {
        return <Dropdown value={e.value} options={e.options} onChange={(event) => e.onChange(event.originalEvent, event.value)} style={{ lineHeight: 1 }} />;
    };

    const yearNavigatorTemplate = (e) => {
        return <Dropdown value={e.value} options={e.options} onChange={(event) => e.onChange(event.originalEvent, event.value)} className="ml-2" style={{ lineHeight: 1 }} />;
    }

    const actionHerramienta = (rowData) => {
        return (
            (rowData.editable == 1 || usuario.superusuario) && (
                <div className="actions">
                    {accionPermiso(permisos, "festivo_editar") && (
                        <Button
                            icon="pi pi-pencil"
                            className="p-button-rounded p-button-success p-mr-2"
                            onClick={() => viewEditar(rowData)}
                        />
                    )}
                    {accionPermiso(permisos, "festivo_eliminar") && (
                        <Button
                            icon="pi pi-trash"
                            className="p-button-rounded p-button-danger"
                            onClick={() => confirmDelete(rowData)}
                        />
                    )}
                </div>
            )
        );
    };


    const saveRegistro = async (values, { setSubmitting }) => {
        try {
            let data = { fecha: dateToString(values.fecha), descripcion: values.descripcion }
            
            dispatch(loading(true));
            let response = []
            if (labelDialog.current.es_nuevo) {
                data.idcolegio = usuario.superusuario ? 0 : colegio.id
                response = await POST('festivo', 'crear', data);
            } else {
                response = await PUT('festivo', 'editar', values.id, data);
            }
            if (response.error) {
                toast.current.show({ severity: 'error', summary: 'Error', detail: `${response.mesage}${!response.detalle ? `. Detalles: ${response.detalle}` : ''}`, life: 3000 });

            } else {
                hideDialog();
                loadLista();
                toast.current.show({ severity: "success", summary: "OK", detail: "Registros guardados!", life: 3000 });
            }
        } catch (error) {
            console.error('Error console:', error);
        } finally {
            dispatch(loading(false));
            setSubmitting(false);
        }
    }

    const validationSchema = Yup.object().shape({
        fecha: Yup.string().required('La fecha es requerida'),
        descripcion: Yup.string().required('La descripción es requerida')
        // Agrega las reglas de validación para los demás campos aquí
    });

    return (
        <div className="p-grid table-demo">
            <div className="p-col-12">
                <Toast ref={toast} />
                <DataTable
                    value={dataTable}
                    paginator
                    id="13"
                    className="p-datatable-customers p-datatable-sm"
                    rows={10}
                    dataKey="id"
                    rowHover
                    globalFilter={globalFilter}
                    emptyMessage="No existe información!"
                    loading={false}
                    header={dataTableHeader}
                    metaKeySelection={true}
                    size="small"
                >
                    <Column field="fecha" header="Fecha" sortable body={bodyTemplate}></Column>
                    <Column field="descripcion" header="Nombre" sortable body={bodyTemplate}></Column>
                    <Column field="estado" header="Estado" sortable body={bodyTemplateActivo}></Column>
                    <Column headerStyle={{ width: "8rem", textAlign: "center" }} bodyStyle={{ textAlign: "center", overflow: "visible", justifyContent: "center" }} body={actionHerramienta}></Column>
                </DataTable>

                <Dialog visible={visibleDialog} style={{ width: "40vw" }} breakpoints={{ "960px": "100vw" }} header={labelDialog.current.title} modal className="p-fluid" onHide={hideDialog}>
                    <Formik
                        initialValues={selectedRecord}
                        validationSchema={validationSchema}
                        onSubmit={saveRegistro}
                    >
                        {({ errors, touched, handleChange, handleBlur, values, isSubmitting }) => (

                            <Form>
                                <div className="p-grid flexgrid-demo">

                                    <div className="p-col-12 p-md-6 p-lg-6">
                                        <label htmlFor="name2">Fecha</label>
                                        <Calendar
                                            id="spanish"
                                            name='fecha'
                                            value={values.fecha} onChange={handleChange} onBlur={handleBlur}
                                            locale="es"
                                            dateFormat="dd/mm/yy"
                                            monthNavigator
                                            yearNavigator
                                            yearRange="2024:2040"
                                            showIcon
                                            monthNavigatorTemplate={monthNavigatorTemplate}
                                            yearNavigatorTemplate={yearNavigatorTemplate}
                                        />
                                        {errors.fecha && touched.fecha && <small className="p-error">{errors.fecha}</small>}
                                    </div>

                                    <div className="p-col-12 p-md-6 p-lg-6">
                                        <label htmlFor="name2">Descripción</label>
                                        <InputText name='descripcion' value={values.descripcion} onChange={handleChange} onBlur={handleBlur} className={classNames({ "p-invalid": errors.descripcion && touched.descripcion })} />
                                        {errors.descripcion && touched.descripcion && <small className="p-error">{errors.descripcion}</small>}
                                    </div>

                                </div>

                                {/* Botones de cancelar y enviar dentro del formulario */}
                                <div className="p-dialog-footer p-pt-3 p-pb-0 p-pl-0 p-pr-0 p-mt-2">
                                    <Button type="button" label="Cancelar" icon="pi pi-times" className="p-button-text" onClick={hideDialog} />
                                    <Button type="submit" label={labelDialog.current.labelButton} icon="pi pi-check" />
                                </div>
                            </Form>
                        )}
                    </Formik>
                </Dialog>
            </div>
        </div>
    );
};
